import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router";
import { withRouter, Redirect } from "react-router-dom";
import { CreateUser, Login, Users } from "../../screens";

import { Website, AddArticle, ReviewArticle } from "../../screens";
import Dashboard from "../../screens/Dashboard/Dashboard";
import { Finances } from "../../screens/Finances";
import { MerchantOperation } from "../../screens/Merchants";
import Merchants from "../../screens/Merchants/Merchants";
import { User } from "../../utilites/User";
import Header from "../Header/Header";
import AddNotification from "../Statistics/Notifications/AddNotification";
import Receivers from "../Statistics/Notifications/Receivers";


import FreeUsers from "../AppGrids/FreeUsers";
import SubscribedUsers from "../AppGrids/SubscribedUsers";
import FreeCommunities from "../AppGrids/FreeCommunities";
import SubscribedCommunities from "../AppGrids/SubscribedCommunities";
import CommunitiesList from "../AppGrids/CommunitiesList/CommunitiesList";
import UsersList from "../AppGrids/UsersList/UsersList";
import ActiveUsersList from "../AppGrids/ActiveUsersList/ActiveUsersList";
import PropertiesList from "../AppGrids/PropertiesList/PropertiesList";
import UserSearch from "../AppGrids/UserSearch/UserSearch";
import AppFinances from "../../screens/App/finance/AppFinances";
import AppProperties from "../../screens/App/properties/AppProperties"; 
import AppCommunities from "../../screens/App/communities/AppCommunities";
import SentToUsersList from "../AppGrids/SentToUsersList/SentToUsersList";
import PropertiesMap from "../AppGrids/PropertiesMap/PropertiesMap";

const AuthRoute = ({ children, ...rest }) => {
  return (
    <Route
      render={({ location }) =>
        !User.isAuthenticated ? (
          <Route {...rest} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: location } }} />
        )
      }
    />
  );
};

const PrivateRoute = ({ children, ...rest }) => {
  return (
    <Route
      render={({ location }) => {
        return User.isAuthenticated ? (
          <Route {...rest} />
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: location } }} />
        );
      }}
    />
  );
};
class Routes extends Component {
  render() {
    return (
      <>
        {User.isAuthenticated ? <Header /> : ""}
        <div className="dashboard-wrap">
          <Switch>
            <AuthRoute exact path="/login" component={Login} />
            <PrivateRoute exact path="/" component={Dashboard} />
            <PrivateRoute
              exact
              path="/notification-send"
              component={AddNotification}
            />
           
            {/* Mock table for "Sent to Users" recipients list */}
            <PrivateRoute
              exact
              path="/notification/sent-users"
              component={SentToUsersList}
            />
            <PrivateRoute path="/notification" component={Receivers} />
            
            <PrivateRoute
              exact
              path="/dashboard/subscriptions/free"
              component={FreeUsers}
            />
            <PrivateRoute
              exact
              path="/dashboard/subscriptions/monthly"
              component={SubscribedUsers}
            />
            <PrivateRoute
              exact
              path="/dashboard/subscriptions/annual"
              component={SubscribedUsers}
            />
            <PrivateRoute
              exact
              path="/dashboard/communities/free"
              component={FreeCommunities}
            />
            <PrivateRoute
              exact
              path="/dashboard/communities/monthly"
              component={SubscribedCommunities}
            />
            <PrivateRoute
              exact
              path="/dashboard/communities/annual"
              component={SubscribedCommunities}
            />
            <PrivateRoute
              exact
              path="/dashboard/communities/list"
              component={CommunitiesList}
            />
            <PrivateRoute
              exact
              path="/dashboard/users/list"
              component={UsersList}
            />
            <PrivateRoute
              exact
              path="/active-users"
              component={ActiveUsersList}
            />
            <PrivateRoute
              exact
              path="/dashboard/properties/list"
              component={PropertiesList}
            />
            <PrivateRoute
              exact
              path="/dashboard/properties/map"
              component={PropertiesMap}
            />
            <PrivateRoute
              exact
              path="/user-search"
              component={UserSearch}
            />
            
            <PrivateRoute exact path="/app/finances" component={AppFinances} />
            <PrivateRoute exact path="/app/properties" component={AppProperties} />
            <PrivateRoute exact path="/app/communities" component={AppCommunities} /> 
            <PrivateRoute exact path="/website" component={Website} />
            <PrivateRoute exact path="/website/add-article" component={AddArticle} />
            <PrivateRoute exact path="/website/edit-article/:articleId" component={AddArticle} />
            <PrivateRoute exact path="/website/article/:articleId" component={ReviewArticle} />
            <PrivateRoute exact path="/finances" component={Finances} />
            <PrivateRoute exact path="/user-management" component={Users} />
            <PrivateRoute
              exact
              path="/user-management/add-user"
              component={CreateUser}
            />
            <PrivateRoute exact path="/merchants" component={Merchants} />
            <PrivateRoute path="/add-merchant" component={MerchantOperation} />
            <PrivateRoute path="/merchant" component={MerchantOperation} />
          </Switch>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { loading: state.starter.loading };
};

export default withRouter(connect(mapStateToProps)(Routes));
